import React from 'react';

// Small icon-only button that toggles a neighboring password input
// between type="password"/"text". Purely presentational — the caller
// owns the shown/hidden state and the input's `type`.
const PasswordToggleButton = (props: { isVisible: boolean, onToggle: () => void }) => {
    return (
        <button type='button' className='passwordToggle-btn'
                onClick={props.onToggle}
                tabIndex={-1}
                aria-label={props.isVisible ? 'Скрыть пароль' : 'Показать пароль'}
                title={props.isVisible ? 'Скрыть пароль' : 'Показать пароль'}>
            {
                props.isVisible ?
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                         strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round">
                        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/>
                        <circle cx="12" cy="12" r="3"/>
                    </svg>
                    :
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                         strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 3l18 18"/>
                        <path d="M10.6 5.2A10.6 10.6 0 0 1 12 5c6.5 0 10 7 10 7a15.6 15.6 0 0 1-3.4 4.3M6.4 6.4A15.7 15.7 0 0 0 2 12s3.5 7 10 7c1.4 0 2.6-.2 3.7-.6"/>
                        <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2"/>
                    </svg>
            }
        </button>
    );
};

export default PasswordToggleButton;
